export const ROUTES = {
    home: '/',
}